export const add = (a: number, b: number) => a + b;

export const round = (val: number) => Math.round((val + Number.EPSILON) * 100) / 100;

export const avg = (numbers: number[]) => numbers.reduce((a, b) => a + b, 0) / numbers.length;
